"use client";

import type React from "react";
import { useState } from "react";
import type { AuthState } from "shared/UtilTypes";
import { useAppRouter } from "src/lib/Navigation";
import { AuthContext, type AuthContextType } from "./AuthContext";

interface AuthProviderProps {
  children: React.ReactNode;
  initialAuthState?: AuthState;
}

export const AuthProvider = (props: AuthProviderProps) => {
  const { children, initialAuthState } = props;

  const [authState, setAuthState] = useState<AuthState | undefined>(initialAuthState);
  const [previousInitialAuthState, setPreviousInitialAuthState] = useState(initialAuthState);
  if (previousInitialAuthState !== initialAuthState) {
    setPreviousInitialAuthState(initialAuthState);
    setAuthState(initialAuthState);
  }

  const router = useAppRouter();

  const signIn = async (_newAuthState: AuthState) => {
    await router.refresh();
  };

  const value: AuthContextType = {
    authState,
    signIn,
    setAuthState,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
